import React from "react";

function VisitGridItems(props) {
  const { children } = props;

  return <>{children}</>;
}

export default VisitGridItems;
